import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';

export default function TermsAndConditions() {
  pageTitle('Điều khoản và điều kiện');

  return (
    <>
      <BannerSectionStyle3
        bgUrl='/images/about/banner_bg.svg'
        imgUrl='/images/about/banner_img.png'
        title='Điều khoản và điều kiện'
        subTitle='Vui lòng đọc kỹ các điều khoản và điều kiện dưới đây trước khi sử dụng website và dịch vụ của Nha khoa Tiến Đức.'
      />
      <Section topMd={100} topLg={80} topXl={60} bottomMd={100} bottomLg={80} bottomXl={60}>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-10 offset-lg-1'>
              <div className='cs_terms_conditions cs_heading_color'>
                <p className='cs_fs_18'>
                  Bằng việc truy cập website và sử dụng dịch vụ của Nha khoa
                  Tiến Đức, Quý khách đồng ý tuân thủ các điều khoản và điều
                  kiện được quy định dưới đây. Nếu không đồng ý với bất kỳ nội
                  dung nào, vui lòng ngừng sử dụng website và dịch vụ của chúng
                  tôi.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  1. Chấp nhận điều khoản
                </h3>
                <p className='cs_fs_18'>
                  Khi Quý khách truy cập, đăng ký tài khoản, đặt lịch hẹn hoặc
                  sử dụng bất kỳ dịch vụ nào trên website, Quý khách được hiểu
                  là đã đọc, hiểu và đồng ý tuân thủ toàn bộ các điều khoản và
                  điều kiện này cùng với Chính sách bảo mật của chúng tôi.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  2. Dịch vụ của chúng tôi
                </h3>
                <p className='cs_fs_18'>
                  Nha khoa Tiến Đức cung cấp các dịch vụ khám, tư vấn và điều
                  trị nha khoa bao gồm nhưng không giới hạn: niềng răng, cấy
                  ghép Implant, bọc răng sứ, tẩy trắng răng, điều trị nha chu,
                  nhổ răng và các dịch vụ nha khoa tổng quát khác. Chi tiết dịch
                  vụ, quy trình và chi phí sẽ được tư vấn cụ thể trước khi thực
                  hiện.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  3. Đặt lịch hẹn và hủy lịch
                </h3>
                <ul className='cs_fs_18'>
                  <li>
                    Quý khách có thể đặt lịch hẹn qua website, hotline hoặc đến
                    trực tiếp phòng khám.
                  </li>
                  <li>
                    Vui lòng cung cấp thông tin chính xác khi đặt lịch để được
                    phục vụ tốt nhất.
                  </li>
                  <li>
                    Trong trường hợp cần hủy hoặc thay đổi lịch hẹn, Quý khách
                    vui lòng thông báo cho chúng tôi trước ít nhất 24 giờ.
                  </li>
                  <li>
                    Nha khoa Tiến Đức có quyền từ chối hoặc hủy lịch hẹn trong
                    trường hợp bất khả kháng và sẽ thông báo lại cho Quý khách
                    trong thời gian sớm nhất.
                  </li>
                </ul>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  4. Trách nhiệm của khách hàng
                </h3>
                <ul className='cs_fs_18'>
                  <li>
                    Cung cấp đầy đủ và trung thực các thông tin cá nhân, tình
                    trạng sức khỏe, tiền sử bệnh lý khi được yêu cầu.
                  </li>
                  <li>
                    Tuân thủ chỉ dẫn của bác sĩ trong quá trình điều trị và
                    chăm sóc sau điều trị.
                  </li>
                  <li>
                    Thanh toán đầy đủ chi phí dịch vụ theo thỏa thuận đã được
                    xác nhận.
                  </li>
                  <li>
                    Không sử dụng website cho các mục đích bất hợp pháp hoặc vi
                    phạm quyền lợi của Nha khoa Tiến Đức và bên thứ ba.
                  </li>
                </ul>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  5. Chi phí và thanh toán
                </h3>
                <p className='cs_fs_18'>
                  Chi phí các dịch vụ được niêm yết công khai tại phòng khám và
                  được tư vấn chi tiết trước khi thực hiện. Quý khách thanh
                  toán theo các hình thức được Nha khoa Tiến Đức chấp nhận:
                  tiền mặt, chuyển khoản, quẹt thẻ. Chi phí có thể thay đổi
                  tùy theo tình trạng thực tế và phương án điều trị được
                  thống nhất giữa hai bên.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  6. Chính sách bảo hành
                </h3>
                <p className='cs_fs_18'>
                  Nha khoa Tiến Đức áp dụng chính sách bảo hành đối với các
                  dịch vụ kỹ thuật theo quy định riêng của từng dịch vụ. Chính
                  sách bảo hành không áp dụng trong các trường hợp do lỗi của
                  khách hàng như: không tuân thủ hướng dẫn chăm sóc, tự ý can
                  thiệp tại cơ sở khác, tai nạn, chấn thương…
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  7. Quyền sở hữu trí tuệ
                </h3>
                <p className='cs_fs_18'>
                  Toàn bộ nội dung trên website bao gồm văn bản, hình ảnh,
                  logo, thương hiệu, thiết kế, mã nguồn… đều thuộc quyền sở
                  hữu của Nha khoa Tiến Đức và được bảo hộ theo quy định của
                  pháp luật. Nghiêm cấm sao chép, sử dụng lại dưới mọi hình
                  thức khi chưa có sự đồng ý bằng văn bản của chúng tôi.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  8. Giới hạn trách nhiệm
                </h3>
                <p className='cs_fs_18'>
                  Nha khoa Tiến Đức không chịu trách nhiệm đối với bất kỳ thiệt
                  hại phát sinh nào do: Quý khách cung cấp thông tin không
                  chính xác, không tuân thủ chỉ dẫn điều trị, hoặc do các sự
                  kiện bất khả kháng nằm ngoài khả năng kiểm soát của chúng
                  tôi.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  9. Thay đổi điều khoản
                </h3>
                <p className='cs_fs_18'>
                  Nha khoa Tiến Đức có quyền cập nhật, thay đổi nội dung điều
                  khoản và điều kiện vào bất kỳ thời điểm nào. Các thay đổi có
                  hiệu lực ngay khi được đăng tải trên website. Việc Quý khách
                  tiếp tục sử dụng dịch vụ sau khi điều khoản được cập nhật
                  đồng nghĩa với việc chấp nhận các thay đổi đó.
                </p>

                <h3 className='cs_fs_32 cs_semibold mb-3 mt-5'>
                  10. Thông tin liên hệ
                </h3>
                <p className='cs_fs_18'>
                  Mọi thắc mắc liên quan đến Điều khoản và điều kiện, Quý khách
                  vui lòng liên hệ:
                </p>
                <ul className='cs_fs_18'>
                  <li>
                    <b>Nha khoa Tiến Đức</b>
                  </li>
                  <li>Hotline: 0968 60 8881 – 0925 247 365</li>
                  <li>
                    Email:{' '}
                    <a href='mailto:hellocallcenter@gmail.com'>
                      hellocallcenter@gmail.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
